module.exports = __webpack_public_path__ + "assets/img/group-logo-0e85f898.png";